<template>
    <div class="font-weight-bold">
      <b-row>
        <b-col>
          <b-card class="g">
            <center>
              내 예치금 : {{ model.credit | number }}
              <hr class="m-2">
              <span v-b-modal.price_modal style="cursor:pointer">
                서비스 타입 (<b-badge variant="primary" >?</b-badge>)
              </span>
              :
              <b-badge :variant="current && current.servicename == 'basic' ? 'primary' : 'success'">{{current && current.servicename}}</b-badge>
            </center>
          </b-card>
        </b-col>
        <b-col>
          <b-card class="g">
            <center>
              <span>이용중인 서비스 목록</span>
            </center>
            <hr class="m-2">
            <center>
              <!-- {{current_service}} -->
              <!-- <b-badge variant="warning">WEBCastle</b-badge> -->
              <b-badge v-if="current_service && current_service.waf && current_service.waf > 0" variant="warning">WEBCastle</b-badge>
              <b-badge v-if="current_service && current && current.servicename != 'Basic' && current_service.wsfinder > 0" variant="danger">WSFinder</b-badge>
              <b-badge v-if="current_service && current_service.integrity && current_service.integrity > 0" variant="info">WFDetector</b-badge>
              <b-badge v-if="current_service && current_service.wmds_site && current_service.wmds_site > 0" variant="dark">WMDS</b-badge>
            </center>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="k">
            <center >가격 안내</center>
            <center v-if="current_service && current_service.id">
              <span v-if="current_service.customer_price > 0 && current_service.customer_price < current_service.base_price">
                <del>{{current_service.base_price | dollar}}</del>
                <br>
                <span>{{current_service.customer_price | dollar}}</span>
              </span>
              <span v-else>
                {{current_service.base_price | dollar}}
              </span>
            </center>
            <center v-else>
              -
            </center>
            <hr>
            <center >지난달 지불 금액</center>
            <center v-if="last_invoice && last_invoice.total_paid > 0">{{last_invoice.total_paid | dollar}}</center>
            <center v-else> - 최근 지불 금액 없음 - </center>
          </b-card>
        </b-col>
        <b-col>
          <b-card class="k text-center">
            오늘(금일 설치도 포함)까지 사용된 금액(현재 달)
            <p v-if="model" class="m-2">
              {{model.total_price | dollar}}
              <!-- {{model.total_price | dollar}} ({{model.agent_usage}} / days) -->
            </p>
            <p v-else> - </p>
            <hr>
            <div v-b-tooltip.hover title="에이전트가 추가되면 다음달 가격이 변경됩니다.">
              이번달 말일까지의 예상 금액
              <p v-if="model" class="m-2">
                {{model.this_month_price | dollar}}
              </p>
              <p v-else> - </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <template slot="header">
              <i class='fa fa-align-justify'></i> 월별 결제 내역
              <!-- <b-checkbox @change="refresh()" class="float-right" v-model="hide_canceled">Hide Cancel</b-checkbox> -->
            </template>
            <b-table hover striped small responsive="sm" ref="_list" show-empty empty-text="There is no payment history!" :items="load" :fields="pay" :current-page="so.currentPage" :per-page="so.perPage">
              <template slot="apply_at" slot-scope="row">{{row.item.apply_date.substring(0, 6)}}</template>
              <template slot="servicename" slot-scope="row">{{row.item.servicename}}</template>
              <template slot="price" slot-scope="row">{{row.item.service_price | dollar}}</template>
              <template slot="usage" slot-scope="row">{{row.item.service_unit.toFixed(2)}} 개.</template>
              <template slot="base_price" slot-scope="row">{{row.item.base_price | dollar}}</template>
              <template slot="discount_price" slot-scope="row">{{row.item.discount_price | dollar}} </template>
              <template slot="total_price" slot-scope="row">
                <span v-if="row.item.is_paid">{{row.item.total_paid | dollar}}</span>
                <span v-else>{{row.item.total_price | dollar}}</span>
              </template>
              <template slot="description" slot-scope="row">{{row.item.description || '-'}} </template>
              <template slot="is_paid" slot-scope="row">
                {{row.item.is_paid ? '결제' : '미결제'}}
                <span @click="modal_history(row.item.history)" v-b-modal.history_modal class="m-2 p-1 bg-success" style="cursor:pointer; border-radius: 5px;" v-if="row.item.history && row.item.history.length > 0">?</span>
              </template>
            </b-table>
            <hr>
            <b-row>
              <b-col class="md-8">
                <b-pagination size="sm"  align="center" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"  />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- {{model.services}} -->
      <price-modal v-if="model && model.services" :services="model.services"></price-modal>
      <history-modal :history="history"></history-modal>
    </div>
</template>
<style>
.a {
  border: 1px solid gray;
  text-align: center;
  font-style: italic;
}
.k {
  /* width : 300px; */
  height: 200px;
  padding: 10px;
}
.g {
  /* width: 33px; */
  height: 100px;
}
.s {
  width: 1075px;
  height: 300px;
}
</style>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
